<p-dialog [(visible)]="visible" [modal]="true" [draggable]="false" [resizable]="false" [style]="{ width: '820px' }" styleClass="export-dialog">
    <ng-template pTemplate="header">
        <h3 class="export-title">{{'EXPORT_TITLE' | translate : { '0': (title()! | translate) } }}</h3>
    </ng-template>
    <div class="export-container">
        <p class="export-subtitle">{{ 'EXPORT_DESC' | translate }}</p>
        <div class="export-grid">
            @for (column of exportColumns; track column.id) {
                <div class="export-item">
                    <p-checkbox [binary]="true" [(ngModel)]="column.checked" [disabled]="column.sticky!"></p-checkbox>
                    <span>{{ column.header | translate: buildHeaderParams(column) }}</span>
                </div>
            }
        </div>
    </div>
    <ng-template pTemplate="footer">
        <div class="export-actions">
            <app-button [type]="'secondary'" [label]="'CANCEL'" (click)="onCancel()"></app-button>
            <app-button [type]="'primary'" [label]="'CONFIRM'" (click)="onConfirm()"></app-button>
        </div>
    </ng-template>
</p-dialog>